<template>
  <section
      class="hero-slanted-double"
      :class="{ 'is-reversed': reverse }"
      :style="{
              '--split-top': splitTop,
              '--split-bottom': splitBottom
              }"
      >
      <div v-if="title === 'Images'" class="hero-content images">
        <img v-for="item in images" :src="item">
      </div>
    <div v-else class="hero-content">
      <h1>{{ title }}</h1>
      <p>{{ subtitle }}</p>
      <slot />
    </div>
  </section>
</template>

<script setup>
  defineProps({
  title: { type: String, default: 'Bienvenue sur EasyGO' },
  subtitle: { type: String, default: 'Trouvez et réservez vos tickets facilement' },
  splitTop: { type: String, default: 'var(--bg-primary)' },
  splitBottom: { type: String, default: 'var(--color-grey-light)' },
  reverse: { type: Boolean, default: false },
  images: { type: Array }
})
</script>

<style scoped>
.hero-slanted-double {
  position: relative;
  padding: 6rem 1rem;
  text-align: center;
  color: var(--bg-primary);
  overflow: hidden;

  background: linear-gradient(
    to bottom,
    var(--split-top) 0%,
    var(--split-top) 50%,
    var(--split-bottom) 50%,
    var(--split-bottom) 100%
    );
}

.hero-slanted-double::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--color-jungle) 0%, var(--color-feuille) 100%);
  clip-path: polygon(0 30%, 100% 0%, 100% 70%, 0 100%);
  z-index: 0;
  transform-origin: center;
}

/* Inversion du sens */
.hero-slanted-double.is-reversed::before {
  transform: scaleX(-1);
}

.hero-slanted-double .hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.hero-content.images {
  display: flex;
  gap: 5rem;
  flex-flow: row wrap;
  width: 100%;
  max-width: 100%;
  justify-content: center;
  padding: 8rem;
}
.hero-content > img {
  max-width: 12.5rem;
}

  @media (max-width: 768px) {
    .hero-slanted-double::before {
      clip-path: polygon(0 4%, 100% 0%, 100% 96%, 0 100%);
    }
    .hero-slanted-double {
      padding: 2rem 1rem;
    }
  }
</style>
